var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6667 29.3327H5.33333C4.59696 29.3327 4 28.7357 4 27.9993V3.99935C4 3.26298 4.59696 2.66602 5.33333 2.66602H26.6667C27.4031 2.66602 28 3.26298 28 3.99935V27.9993C28 28.7357 27.4031 29.3327 26.6667 29.3327ZM9.33333 7.99935V13.3327H14.6667V7.99935H9.33333ZM9.33333 15.9993V18.666H22.6667V15.9993H9.33333ZM9.33333 21.3327V23.9993H22.6667V21.3327H9.33333ZM17.3333 9.33268V11.9993H22.6667V9.33268H17.3333Z",
    fill: "#768694"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.88b9af4210f1053955daa010d8473222.svg";
export { ForwardRef as ReactComponent };